export const DEFAULT_SEARCH_TYPE = 'lead';

export const VALID_SEARCH_TYPES = Object.freeze([
    'lead',
    'user',
    'vehicle',
    'recent',
    'note',
    'customer',
]);

type SearchQuery = Record<string, unknown> & {
    type?: unknown;
    value?: unknown;
};

type SearchRouteLocation = {
    hash?: string;
    query?: SearchQuery;
};

type SearchRouteRedirect = true | { hash?: string; name: 'search'; query: SearchQuery };

const normalizeSearchValue = (value: unknown): string => {
    return typeof value === 'string' ? value : '';
};

export const normalizeSearchType = (type: unknown): string => {
    if (typeof type === 'string' && VALID_SEARCH_TYPES.includes(type)) {
        return type;
    }

    return DEFAULT_SEARCH_TYPE;
};

export const normalizeSearchState = (query: SearchQuery = {}): { type: string; value: string } => {
    const type = normalizeSearchType(query.type);

    return {
        type,
        value: type === 'recent' ? '' : normalizeSearchValue(query.value),
    };
};

export const getCanonicalSearchQuery = (query: SearchQuery = {}): SearchQuery | null => {
    const type = normalizeSearchType(query.type);

    if (query.type === type) {
        return null;
    }

    return {
        ...query,
        type,
    };
};

export const getSearchRouteRedirect = (to?: SearchRouteLocation): SearchRouteRedirect => {
    const query = getCanonicalSearchQuery(to?.query);

    if (!query) {
        return true;
    }

    const redirect: Exclude<SearchRouteRedirect, true> = {
        name: 'search',
        query,
    };

    if (to?.hash) {
        redirect.hash = to.hash;
    }

    return redirect;
};
